// Keeps the page a user was opening across login, so a case link from an email still opens the case.
//   session expired on /warranty/2829 -> /login?returnTo=%2Fwarranty%2F2829 -> login -> /warranty/2829

const RETURN_TO = "returnTo";
const DEFAULT_AFTER_LOGIN = "/household";

export const PUBLIC_ROUTES = [
  "/login",
  "/reset-password",
  "/forgot-password",
  "/change-email",
  "/login/about",
  "/unsubscribe",
];

const isPublicPath = (path: string) => path === "/" || PUBLIC_ROUTES.some((route) => path.startsWith(route));

// Only paths inside the app: "/x", never "//host" or "/\host" (another site) and never a login page.
const isReturnablePath = (path: string) =>
  path.startsWith("/") && !path.startsWith("//") && !path.startsWith("/\\") && !isPublicPath(path);

export const loginPathFor = (location: { pathname: string; search?: string; hash?: string }): string => {
  const target = `${location.pathname}${location.search ?? ""}${location.hash ?? ""}`;
  return isReturnablePath(target) ? `/login?${RETURN_TO}=${encodeURIComponent(target)}` : "/login";
};

export const pathAfterLogin = (search: string): string => {
  const target = new URLSearchParams(search).get(RETURN_TO);
  return target && isReturnablePath(target) ? target : DEFAULT_AFTER_LOGIN;
};
